(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-main-knee"]) return;
  try {
    
(function(){function init(root){if(root.dataset.trustReady)return;root.dataset.trustReady='1';const dialog=root.querySelector('[data-gallery-dialog]'),large=root.querySelector('[data-gallery-large]'),main=root.querySelector('[data-main-img]'),thumbs=[...root.querySelectorAll('[data-thumb]')];const previous=root.querySelector('[data-gallery-prev]'),next=root.querySelector('[data-gallery-next]');function step(delta){let index=thumbs.findIndex(t=>t.classList.contains('sk-on'));thumbs[(index+delta+thumbs.length)%thumbs.length]?.click();}previous?.addEventListener('click',()=>step(-1));next?.addEventListener('click',()=>step(1));root.querySelector('[data-gallery-zoom]')?.addEventListener('click',()=>{large.src=(root.querySelector('.mouvea-gallery__slide[aria-current="true"] img')||main).src;dialog.showModal();});root.querySelector('[data-gallery-close]')?.addEventListener('click',()=>dialog.close());dialog?.addEventListener('click',e=>{if(e.target===dialog)dialog.close();});const summary=root.querySelector('[data-ss-order-check]');function recap(){if(!summary)return;const offer=root.querySelector('[data-offer].sk-on');const qty=Number(offer?.dataset.qty||1);const fields=qty>1?[...root.querySelectorAll('[data-offer].sk-on [data-piece]')]:[...root.querySelectorAll('input[data-opt]:checked')];const text=fields.map(i=>i.value).join(' / ').replace(/White-Right/g,'Genou droit').replace(/White-Left/g,'Genou gauche');summary.textContent=summary.dataset.label+': '+qty+' × '+text;} root.addEventListener('change',()=>setTimeout(recap,0));root.addEventListener('click',e=>{if(e.target.closest('[data-offer]'))setTimeout(recap,0);});recap();const helper=root.querySelector('[data-fit-helper]');if(!helper)return;const parsed=new DOMParser().parseFromString(helper.dataset.fitChart,'text/html');const rows=[...parsed.querySelectorAll('tr')].slice(1).map(row=>{const cells=row.querySelectorAll('td');const ranges=(cells[1]?.textContent||'').match(/[0-9]+(?:\.[0-9]+)?/g)?.map(Number)||[];return {size:cells[0]?.textContent.trim(),in:ranges.slice(0,2),cm:ranges.slice(2,4)};});const result=helper.querySelector('[data-fit-result]'),apply=helper.querySelector('[data-fit-apply]');let match;helper.querySelector('[data-fit-form]').addEventListener('submit',e=>{e.preventDefault();const value=Number(helper.querySelector('[data-fit-measure]').value),unit=helper.querySelector('[data-fit-unit]').value;match=rows.find((row,i)=>value>=row[unit][0]&&(value<row[unit][1]||(i===rows.length-1&&value===row[unit][1])));result.textContent=match?result.dataset.result+' '+match.size:result.dataset.outside;apply.hidden=!match;});helper.querySelectorAll('input,select').forEach(el=>el.addEventListener('input',()=>{match=null;apply.hidden=true;result.textContent='';}));apply.addEventListener('click',()=>{if(!match)return;const size=[...root.querySelectorAll('input[data-opt]')].find(i=>i.value===match.size);const color=[...root.querySelectorAll('input[data-opt]:checked')].find(i=>/White|Black/.test(i.value))?.value.split('-')[0]||'White';const side=[...root.querySelectorAll('input[data-opt]')].find(i=>i.value===color+'-'+helper.querySelector('[data-fit-side]').value);if(!size||!side||size.disabled||side.disabled){result.textContent=result.dataset.unavailable;return;}side.checked=true;size.checked=true;size.dispatchEvent(new Event('change',{bubbles:true}));result.textContent=result.dataset.applied;});}document.querySelectorAll('.ss-knee-pdp').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('.ss-knee-pdp').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-motion-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(root.dataset.ready)return;root.dataset.ready='1';const track=root.querySelector('[data-motion-track]'),toggle=root.querySelector('[data-motion-toggle]');let paused=matchMedia('(prefers-reduced-motion: reduce)').matches;const images=[...root.querySelectorAll('[data-motion-image]')];let visible=new Set();function render(){toggle.setAttribute('aria-pressed',String(paused));toggle.textContent=paused?toggle.dataset.play:toggle.dataset.pause;images.forEach(img=>{const src=!paused&&visible.has(img)&&!document.hidden?img.dataset.motionSrc||img.dataset.poster:img.dataset.poster;if(img.getAttribute('src')!==src)img.src=src;});}const observer=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting)visible.add(e.target);else visible.delete(e.target);});render();},{threshold:.2});images.forEach(img=>observer.observe(img));toggle.addEventListener('click',()=>{paused=!paused;render();});root.querySelector('[data-motion-prev]').addEventListener('click',()=>track.scrollBy({left:-(track.querySelector('article').offsetWidth+22),behavior:paused?'instant':'smooth'}));root.querySelector('[data-motion-next]').addEventListener('click',()=>track.scrollBy({left:track.querySelector('article').offsetWidth+22,behavior:paused?'instant':'smooth'}));document.addEventListener('visibilitychange',render);render();}
document.querySelectorAll('[data-ss-motion]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ss-motion]').forEach(init));})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-product-explorer"] && !Shopify.designMode) return;
  try {
    
(function(){function init(root){if(root.dataset.ready)return;root.dataset.ready='1';root.querySelectorAll('[data-feature]').forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.feature;root.querySelectorAll('[data-feature]').forEach(b=>{const active=b.dataset.feature===key;b.classList.toggle('is-active',active);if(b.hasAttribute('aria-expanded'))b.setAttribute('aria-expanded',String(active));else b.setAttribute('aria-pressed',String(active));});root.querySelectorAll('[data-feature-panel]').forEach(panel=>panel.hidden=panel.dataset.featurePanel!==key);}));}document.querySelectorAll('[data-ss-explore]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-ss-explore]').forEach(init));})();

  } catch(e) { console.error(e); }
})();
})();
